// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"532":"e48688ad","633":"78159172","672":"05ced90d"}[chunkId] + ".css";
};